import React, { Component } from 'react';

import style from "./Mark.scss";

class Mark extends Component
{
    constructor(props)
    {
        super(props);
        this.markRef = React.createRef();
    }

    onDragStart(e, id)
    {
        e.dataTransfer.setData('text/plain', id);
    };

    moveMark(fromLeft, fromTop)
    {
        this.markRef.current.style.left = fromLeft+'%';
        this.markRef.current.style.top = fromTop+'%';
    }

    render()
    {
        let mark = this.props.mark;

        let classNames = require('classnames');
        let markClasses = classNames({
            [style.mark]: true,
            [style.locked]: this.props.lockMode
        });

        return (
            <div className={markClasses}
                 style={{'left': mark.fromLeft+'%', 'top': mark.fromTop+'%', 'background': mark.color}}
                 id={'mark-'+mark.id}
                 draggable={!this.props.lockMode}
                 onDragStart={(e)=>this.onDragStart(e, mark.id)}
                 ref={this.markRef}
            />
        )
    }
}

export default Mark;
